// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
  BUTTONS: '.car-funding__tabs-button',
  TAB_CONTENT: '.car-funding__tab-content',
  BUTTONS_WRAPPER: '.car-funding__tabs-buttons',
  CONTENT_WRAPPER: '.car-funding__tabs-content',
};

class Tabs extends WebComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.buttons = [];
    this.tabContents = [];
  }

  didMount() {
    this.buttons = Array.from(this.element.querySelectorAll(fragments.BUTTONS));
    this.tabContents = Array.from(this.element.querySelectorAll(fragments.TAB_CONTENT));
    this.buttons.forEach((button) => {
      button.addEventListener('click', this.handleClick);
    });
  }

  handleClick(e) {
    const clickedButton = e.currentTarget;
    const tabId = clickedButton.getAttribute('data-tab');
    this.buttons.forEach((btn) => {
      btn.classList.toggle('car-funding__tabs-button--active', btn === clickedButton);
    });
    this.tabContents.forEach((tab) => {
      tab.classList.toggle('car-funding__tab-content--active', tab.getAttribute('data-tab') === tabId);
    });
  }

  willUnMount() {
    if (this.buttons && this.buttons.length) {
      this.buttons.forEach((button) => {
        button.removeEventListener('click', this.handleClick);
      });
    }
  }
}

export default Tabs;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Tabs.js